const PageTitle =  (theme) => {
  return {
    fontFamily: 'Urbanist-bold',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(28),
  }
}
export {PageTitle}